<template>
  <section>
    <div class="container" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
      <div>
        <HeaderDateil></HeaderDateil>
      </div>
      <div class="paperdetail">
        <div
          style="padding-left: 50%; font-size: 30px; font-weight: bold;padding-top: 20px;"
        >{{ trainName }}</div>
        <div style="display: flex; padding-top: 20px">
          <div style="padding-left: 30%; font-size: 18px">
            <span >姓名：{{userName}}</span>
          </div>
          <div style="padding-left: 1%; font-size: 18px">
            <span >部门：{{deptName}}</span>
          </div>
          <div style=" padding-left: 1%;font-size: 18px">
            <span>得分: {{ allScore.toFixed(2) }}</span>
          </div>
        </div>
      </div>
      <div class="zhuti">
        <div class="title" v-if="dxt != 0">
          <span style="padding-left: 30px">单选题</span>
          <span style="padding-left: 10px">(共{{ dxt }}题，合计{{ dxtSum.toFixed(2) }}分)</span>
        </div>
        <div v-for="(item, index) in abc" :key="index" v-if="item.type == 1">
          <div class="hhh">
            <div class="sss">
              <!-- 题目展示 -->
              <div class="subject">
                <span class="padding-r5">{{ index + 1 }}.</span>
                <span v-html="item.title" :id="item.id"></span>
              </div>
            </div>
            <!-- 选择区域 -->
            <div class="select-box">
              <ul>
                <li v-for="(items, indexs) in item.answer" :key="indexs">
                  <label :for="item.Id" class="xz-label">
                    <input
                      disabled
                      type="radio"
                      v-model="item.value"
                      :value="items.Id"
                      :id="item.Id"
                      style=" margin-right: 10px;"
                    />
                    <span style="text-index: -2em;padding-right: 5px;"> {{String.fromCharCode(64 + parseInt(indexs+1))}}.</span>
                    {{ items.Name }}
                  </label>
                </li>
              </ul>
            </div>
            <div class="answer" v-if="Status == true">
              <div v-for="(items, indexs) in item.answer" :key="indexs"  class="daan-box" v-if=" items.IsRight == true">
                <span v-if=" items.IsRight == true">正确答案：{{String.fromCharCode(64 + parseInt(indexs+1))}}</span>
              </div>
              <div v-for="(items, indexs) in item.answer" :key="indexs"  class="daan-box" v-if="items.IsCheck">
                <span v-if="items.IsCheck">选择的答案：{{String.fromCharCode(64 + parseInt(indexs+1))}}</span>
              </div>
              <!-- <div style="margin-left: 40px">
                <span v-if="item.CheckAnswer.Value==''">选择的答案：未作答</span>
              </div> -->
            </div>
            <div class="analysis" v-if="Status == true && item.explain">
              <span>解析：{{ item.explain }}</span>
            </div>
          </div>
        </div>
        <div class="title" v-if="ddxt != 0">
          <span style="padding-left: 30px">多选题</span>
          <span style="padding-left: 10px">(共{{ ddxt }}题，合计{{ ddxtSum.toFixed(2) }}分)</span>
        </div>
        <div v-for="(item, index1) in abc" :key="index1" v-if="item.type == 2">
          <div class="hhh">
            <div class="sss">
              <div class="subject">
                <span class="padding-r5">{{ index1 + 1 }}.</span>
                <span v-html="item.title" :id="item.id"></span>
              </div>
            </div>
            <div class="select-box">
              <ul>
                <li v-for="(items, indexs1) in item.answer" :key="indexs1" :id="items.Name">
                  <label :for="item.Id" class="xz-label">
                    <input
                      disabled
                      type="checkbox"
                      v-model="items.IsCheck"
                      :value="items.Id"
                      style="margin-right: 10px;"
                      :id="item.Id"
                    />
                    <span style="text-index: -2em;padding-right: 5px;"> {{String.fromCharCode(64 + parseInt(indexs1+1))}}.</span>
                    {{items.Name}}
                  </label>
                </li>
              </ul>
            </div>
            <div class="answer" v-if="Status == true">
              <div class="rightanswer">
                <div>正确答案：</div>
                <div v-for="(items, indexs) in item.answer" :key="indexs" v-if="items.IsRight">
                  <span v-if="items.IsRight == true">{{String.fromCharCode(64 + parseInt(indexs+1))}}</span>
                </div>
              </div>
              <div class="mychange" v-if="item.MyCate != ''">
                <div v-if="item.MyCate != ''">选择的答案：</div>
                <div v-for="(aaa, bbb) in item.answer" :key="bbb" v-if="item.IsCheck">
                  <span>{{String.fromCharCode(64 + parseInt(bbb+1))}}</span>
                </div>
              </div>
              <!-- <div class="mychange" v-if="item.MyCate == ''">
                <span>选择的答案：未作答</span>
              </div> -->
            </div>
            <div class="analysis" v-if="Status == true  && item.explain">
              <span>解析：{{ item.explain }}</span>
            </div>
          </div>
        </div>
        <div class="title" v-if="pdt != 0">
          <span style="padding-left: 30px">判断题</span>
          <span style="padding-left: 10px">(共{{ pdt }}题，合计{{ pdtSum.toFixed(2) }}分)</span>
        </div>
        <div v-for="(item, index2) in abc" :key="index2" v-if="item.type == 3">
          <div class="hhh">
            <div class="sss">
              <div class="subject">
                <span class="padding-r5">{{ index2 + 1 }}.</span>
                <span v-html="item.title" :id="item.id"></span>
              </div>
            </div>
            <div style="padding-left: 35px; line-height: 50px">
              <label :for="item.Id" class="xz-label">
                <input
                  disabled
                   v-for="(items, indexs) in item.answer"
                  :checked="items.IsCheck"
                  :key="indexs+'a'"
                  :id="item.Id"
                  :name="item.id"
                  type="radio"
                  style="margin-right: 10px"
                />
                正确
              </label>

              <label class="xz-label" :for="item.Id">
                <input
                  disabled
                  v-for="(items, indexs) in item.answer"
                  :checked="!items.IsCheck && item.MyCate"
                  :key="indexs+'b'"
                  :id="item.Id"
                  :name="item.id"
                  type="radio"
                  style="margin-right: 10px"
                />
                错误
              </label>
            </div>
            <div class="answer" v-if="Status == true" >
              <div v-for="(items, indexs) in item.answer" :key="indexs" :id="items.Name" >
                <span v-if="items.IsRight == true">正确答案：正确</span>
                <span v-if="items.IsRight == false">正确答案：错误</span>
              </div>
              <div style="margin-left: 40px">
                <span v-if="item.CheckAnswer.Value == 'true'">选择的答案：正确</span>
                <span v-else-if="item.CheckAnswer.Value == 'false'">选择的答案：错误</span>
                <!-- <span v-else>选择的答案：无</span> -->
              </div>
            </div>
            <div class="analysis" v-if="Status == true  && item.explain">
              <span>解析：{{ item.explain }}</span>
            </div>
          </div>
        </div>
        <div class="title" v-if="tkt != 0">
          <span style="padding-left: 30px">填空题</span>
          <span style="padding-left: 10px">(共{{ tkt }}题，合计{{ tktSum.toFixed(2) }}分)</span>
        </div>
        <div v-for="(item, index4) in abc" :key="index4" v-if="item.type == 4">
          <div class="hhh">
            <div class="sss">
              <div class="subject">
                <span class="padding-r5">{{ index4 + 1 }}.</span>
                <span v-html="item.title" :id="item.id"></span>
              </div>
            </div>
            <div>
              <el-input
                v-for="(items, indexs2) in item.answer"
                disabled
                :key="indexs2"
                v-model="items.letter"
                placeholder="请输入内容"
                style="
                  width: 95%;
                  padding-left: 30px;
                  padding-top: 10px;
                  padding-bottom: 10px;
                "
              >
                <template slot="prepend">{{ indexs2 + 1 }}</template>
              </el-input>
            </div>
            <div class="answer" style="flex-wrap: wrap;" v-if="Status == true">
              <div
                class="answer-true"
                v-for="(items, indexs) in item.answer"
                :key="indexs"
                style="width: 100%"
              >
                <p :title="items.Name">正确答案：{{ items.Name }}</p>
              </div>
            </div>
            <div class="analysis" v-if="Status == true  && item.explain">
              <span>解析：{{ item.explain }}</span>
            </div>
          </div>
        </div>
        <div class="title" v-if="wdt != 0">
          <span style="padding-left: 30px">问答题</span>
          <span style="padding-left: 10px">(共{{ wdt }}题，合计{{ wdtSum.toFixed(2) }}分)</span>
        </div>
        <div v-for="(item, index3) in abc" :key="index3" v-if="item.type == 5">
          <div class="hhh">
            <div class="sss">
              <div class="subject">
                <span class="padding-r5">{{ index3 + 1 }}.</span>
                <span v-html="item.title" :id="item.id"></span>
              </div>
            </div>
            <div>
              <el-input
                disabled
                v-for="(items, indexs2) in item.answer"
                :key="indexs2"
                v-model="items.letter"
                type="textarea"
                :rows="6"
                placeholder="请输入内容"
                style="
                  width: 95%;
                  padding-left: 30px;
                  padding-top: 10px;
                  padding-bottom: 20px;
                "
              ></el-input>
            </div>
            <div class="answer" v-if="Status==true">
              <div v-for="(items, indexs) in item.answer" :key="indexs" class="right-key">
                <span :title="items.Name">正确答案：{{ items.Name }}</span>
              </div>
            </div>
            <div class="analysis" v-if="Status == true  && item.explain">
              <span>解析：{{ item.explain }}</span>
            </div>
          </div>
        </div>
        <div class="title" v-if="sct!= 0">
          <span style="padding-left: 30px">实操题</span>
          <span style="padding-left: 10px">(共{{ sct }}题，合计{{ sctSum.toFixed(2) }}分)</span>
        </div>
        <div v-for="(item, index6) in abc" :key="index6" v-if="item.type == 6">
          <div class="hhh">
            <div class="sss">
              <div class="subject">
                <span class="padding-r5">{{ index6 + 1 }}.</span>
                <span v-html="item.title" :id="item.id"></span>
              </div>
              <div @click="getId(abc[index6].id)">
                <el-popover
                  placement="bottom-end"
                  width="400"
                  v-model="item.visible"
                  trigger="click"
                >
                  <el-form :model="temp" label-position="right" label-width="100px">
                    <el-form-item size="small" :label="'问题类型：'" prop="typeDicId" required>
                      <el-radio-group v-model="temp.typeDicId">
                        <el-radio :label="1">题目不完整</el-radio>
                        <el-radio :label="2">答案不正确</el-radio>
                        <el-radio :label="3">含有错别字</el-radio>
                        <el-radio :label="4">图片不存在</el-radio>
                        <el-radio :label="5">解析不完整</el-radio>
                        <el-radio :label="6">其他错误</el-radio>
                      </el-radio-group>
                    </el-form-item>

                    <el-form-item size="small" :label="'意见：'" prop="idea">
                      <el-input v-model="temp.idea"  type="textarea"></el-input>
                    </el-form-item>
                  </el-form>
                  <div style="text-align: right; margin: 0">
                    <el-button type="primary" size="mini" @click="submitWrong(item)">确定</el-button>
                  </div>
                  <i
                    class="el-icon-question"
                    style="color: red;margin-right: 10px;"
                    slot="reference"
                    title="题目反馈"
                    ref="wrongRef"
                  ></i>
                </el-popover>
                <i
                  v-if="item.bjStatus == true"
                  class="iconfont icon-qizi-copy"
                  @click="biaoji(item, index6)"
                ></i>
                <i v-else class="iconfont icon-qizi" @click="biaoji(item, index6)"></i>
              </div>
            </div>
            <div class="rules-box">
              <el-input
                :value="item.rules"
                type="textarea"
                :rows="8"
                disabled
                style="
                  width: 95%;
                  padding-left: 30px;
                  padding-bottom: 20px;
                "
              >
              </el-input>
            </div>
          </div>
        </div>
      </div>
      <!-- 答题卡 -->
      <div>
        <left :class="[fix == true ? 'fixed' : 'leftzj']" ref="left" :questionList="questionList" v-if="questionList"></left>
      </div>
      <div class="tj">
        <el-button type="primary" @click="btnSubmit">退出</el-button>
        <el-button type="primary" @click="restExam">重考</el-button>
      </div>
    </div>
  </section>
</template>

<script>
import vHeader from '../../header/index';
import left from './leftPerson';
import {
  SelectPaperQuestion,
  SelectPaperDetail,
  GetDetail,
  EnterPaper,
  SelectQuestion,
} from '../../../api/exam/paper';
import * as pmiDictionary from '@/api/pmi/dictionarys';
import * as pmiDept from '@/api/pmi/dept';
import HeaderDateil from '@/components/headerDateil';
import * as ApiPerson from '@/api/personcenter/index';
import { getInfo} from '@/utils/auth';
export default {
  components: {
    vHeader,
    left,
    HeaderDateil,
  },
  data() {
    return {
      trainName: '',
      subjectList: [],
      deptList: [],
      abc: [],
      dxt: 0,
      dxtSum: 0,
      tkt: 0,
      tktSum: 0,
      pdt: 0,
      pdtSum: 0,
      wdt: 0,
      wdtSum: 0,
      ddxt: 0,
      ddxtSum: 0,
      sct:0,
      sctSum:0,
      allSum: 0,
      Status: false,
      paperId: localStorage.getItem('paperId'),
      Ids: localStorage.getItem('Id'),
      fix: false,
      PaperDetail: [],
      ExamDetail: [],
      dialogVisible: false,
      loading: false, //遮罩层
      allScore: 0, //总分
      userName:'无',
      deptName:'无',
      temp: {
        questionId: 0,
        typeDicId: null,
        idea: '',
        status: 0,
        createId: 0,
      },
      questionList:null,

    };
  },
  beforeRouteLeave (to, from, next) {
    sessionStorage.removeItem("list")
    sessionStorage.removeItem("tijiao")
    next()
  },
  methods: {
    //获取所有科目
    getSubjectList() {
      let _this = this;
      let data = { NamespaceId: 6 };
      pmiDictionary.getList(data).then((res) => {
        res.data.forEach(function (item, index) {
          let modeInfo = {};
          modeInfo.value = item.id;
          modeInfo.label = item.name;
          _this.subjectList.push(modeInfo);
        });
      });
    },
    //获取所有部门
    getCateList() {
      let _this = this;
      let para = {
        Page: 1,
        Limit: 100,
      };
      pmiDept.getList(para).then((res) => {
        res.data.forEach(function (item, index) {
          let modeInfo = {};
          modeInfo.value = item.id;
          modeInfo.label = item.name;
          _this.deptList.push(modeInfo);
        });
      });
    },
    
    //点击退出按钮
    btnSubmit() {
      sessionStorage.removeItem('list');
      sessionStorage.removeItem("tijiao")
      this.$router.push({
        path: '/personCenter/iamStudy',
      });
    },
    //重考
    restExam(){
      sessionStorage.removeItem('list');
      sessionStorage.removeItem("tijiao")
      this.$router.go(-1)
    },
    getList() {
      this.allScore = parseInt(this.$route.query.score);
      let para = {
        trainId: this.$route.query.trainId,
      };
      ApiPerson.getOfficial(para).then((res) => {
        
       let list= sessionStorage.getItem('list');
       if(list){
         this.abc = JSON.parse(list)
       }else{
          
          for (let i = 0; i < res.data.length; i++) {
          res.data[i].answer = JSON.parse(res.data[i].answer);
          res.data[i].bjStatus = false;
          res.data[i].MyCate = false;
          res.data[i].value = '';
          res.data[i].CheckAnswer = [];
          res.data[i].visible = false;
          }
          this.abc = res.data
         
       }
       for (let i = 0; i < this.abc.length; i++) {
          this.abc[i].answer = JSON.parse(JSON.stringify(this.abc[i].answer));
          if (this.abc[i].type == 1) {
            this.dxt += 1;
            this.dxtSum += this.abc[i].score;
          } else if (this.abc[i].type == 2) {
            this.ddxt += 1;
            this.ddxtSum += this.abc[i].score;
          } else if (this.abc[i].type == 3) {
            this.pdt += 1;
            this.pdtSum += this.abc[i].score;
          } else if (this.abc[i].type == 5) {
            this.wdt += 1;
            this.wdtSum += this.abc[i].score;
          } else if (this.abc[i].type == 4) {
            this.tkt += 1;
            this.tktSum += this.abc[i].score;
          } else if (this.abc[i].type == 6) {
            this.sct += 1;
            this.sctSum += this.abc[i].score;
          }
        }
        this.abc=this.abc
        this.questionList=JSON.stringify(this.abc)
        this.allSum = this.abc.length;
      });
    },
    //查询试卷信息
    getpaper() {
      let para = {
        id: this.paperId,
      };
      SelectPaperDetail(para).then((res) => {
        this.PaperDetail = res.result;
        
      });
    },
    //查询考试信息
    getexam() {
      let para = {
        id: this.Ids,
      };
      GetDetail(para).then((res) => {
        this.ExamDetail = res.result;
        this.trainName = this.$route.query.trainName;
      });
    },
  },
  created() {
  
    if(JSON.parse(getInfo('infos'))){
      this.temp.createId=JSON.parse(getInfo('infos')).id
      this.userName=JSON.parse(getInfo('infos')).name
      this.deptName=JSON.parse(getInfo('infos')).deptName
      // this.getCateList();

    }
    if(this.$route.query.status){
      this.Status = true;
    }else{
      this.Status = false;
    }
    //左悬浮div吸顶
    window.onscroll = () => {
      var scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      if (scrollTop >= 418) {
        this.fix = true;
      } else if (scrollTop < 418) {
        this.fix = false;
      }
    };
    this.getList();
    this.getexam();
    // this.getpaper();
  },
  mounted() {
    if (this.Status == true) {
      for (let i = 0; i < this.abc.length; i++) {
        for (let j = 0; j < this.abc[i].answer.length; j++) {
          if (this.abc[i].answer[j].IsRight) {
            this.abc[i].value = this.abc[i].answer[j].Id;
          }
        }
      }
    }
  },
  watch: {
    dialogVisible: {
      handler() {
        if (this.dialogVisible == false) {
          clearInterval(this.timer);
        }
      },
    },
  },
  destroyed() {
    // this.aaa();
  },
};
</script>

<style scoped>
@import url('../../../assets/font_81dv624ewpl/iconfont.css');
.container {
  width: 100%;
}
.zhuti {
  width: 50%;
  background-color: white;
  margin-top: 20px;
  margin-left: 30%;
  border-left: 1px solid #f2f2f2;
  border-right: 1px solid #f2f2f2;
  margin-bottom: 30px;
  /* height: 720px; */
  overflow: auto;
  border-radius: 5px;
  min-height: 700px;
}
.title {
  width: 100%;
  height: 40px;
  padding-top: 15px;
  font-size: 18px;
  background-color: #fafafa;
  /* border-left: 1px dashed rgb(226, 223, 223);
  border-right: 1px dashed rgb(226, 223, 223); */
  border-bottom: 1px dashed rgb(226, 223, 223);
  border-top: 1px dashed rgb(226, 223, 223);
}
li {
  padding-left: 40px;
  list-style: none;
  font-size: 30px;
  padding-bottom: 10px;
}
.leftzj {
  position: absolute;
  left: 12%;
  top: 180px;
  overflow-y: auto;
     height: 75vh;
     overflow-x: hidden;
}
.tj {
  position: fixed;
  right: 8%;
  bottom: 120px;
}
.fixed {
  position: fixed;
  left: 12%;
  top: 20px;
  overflow-y: auto;
     height: 75vh;
     overflow-x: hidden;
}
.icon {
  width: 1em;
  height: 1em;
  font-size: 20px;
}
.icons {
  width: 1em;
  height: 1em;
  font-size: 15px;
}
.bj {
  background-color: #1a8cfe;
}
.sss {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  margin-left: 20px;
  margin-right: 20px;
}
.hhh {
  border-radius: 5px;
  /* border: 1px solid #f2f2f2; */
  /* margin-bottom: 20px; */
  padding-top: 20px;
}
.answer {
  display: flex;
  width: 92%;
  margin-left: 4%;
  border-bottom: 1px dashed rgb(226, 223, 223);
  line-height: 40px;
  
}
.analysis {
  width: 92%;
  margin-left: 4%;
  /* border-top: 1px dashed rgb(226, 223, 223); */
  line-height: 40px;
  
}
.mychange {
  display: flex;
  width: 150px;
}
.rightanswer {
  display: flex;
  width: 150px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.progress {
  z-index: 2000;
  text-align: center;
  position: fixed;
  left: 39.5%;
  top: 35%;
  height: 250px;
  width: 400px;
  border: 1px solid rgb(226, 223, 223);
  border-radius: 5px;
  background-color: #fafafa;
}
.subject {
  display: flex;
  align-items: baseline;
}
.padding-r5{
  padding-right: 5px;
  font-size: 16px;
}
.xz-label {
  font-size: 15px;
  display: flex;
  width: 95%;
  align-items: baseline;
}
.xz-label:hover {
  background-color: whitesmoke;
}
.paper-time {
  width: 120px;
  height: 50px;
  line-height: 25px;
  border-bottom: 1px solid rgb(226, 223, 223);
  border-radius: 5px;
  text-align: center;
  padding: 10px 0;
}
.red-color {
  color: red;
  font-size: 18px;
}
.paper-box {
  display: flex;
  flex-direction: column;
  position: fixed;
  right: 225px;
  top: 180px;
  width: 120px;
  height: 200px;
  font-size: 14px;
  font-weight: 400;
  border: 1px solid rgb(226, 223, 223);
  border-radius: 5px;
  text-align: center;
  padding: 10px 0;
}
.paper-progress {
  display: flex;
  flex-direction: column;
  line-height: 30px;
  height: 80px;
  border-bottom: 1px solid rgb(226, 223, 223);
  padding: 10px 0;
}

.right-key {
  margin-bottom: 10px;
}
.rules-box{
  display: flex;
  margin-top: 10px;
}
.select-box{
  margin-top: 15px;
}
@media (max-width: 1366px){
  .leftzj {
    position: absolute;
    left: 9%;
    top: 180px;
    overflow-y: auto;
     height: 75vh;
     overflow-x: hidden;
  }
  .fixed {
    position: fixed;
    left: 9%;
    top: 20px;
    overflow-y: auto;
     height: 75vh;
     overflow-x: hidden;
  }
}
@media (max-width: 1680px){
  .leftzj {
    position: absolute;
    left: 10%;
    top: 180px;
    overflow-y: auto;
    height: 75vh;
    overflow-x: hidden;
  }
  .fixed {
    position: fixed;
    left: 10%;
    top: 20px;
    overflow-y: auto;
    height: 75vh;
    overflow-x: hidden;
  }
}
.daan-box{
  display: flex;
  min-width: 100px;
}
.daan-box>span{
min-width: 120px;
}
.test-description{
  width: 50%;
  margin: 0 auto;
  margin-left: 30%;
  margin-top: 20px;
  line-height: 25px;
  font-size: 15px;
  text-indent: 2em;
}
</style>